webpackJsonp([1],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rx__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_rx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_skeleton_css_css_normalize_css__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_skeleton_css_css_normalize_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_skeleton_css_css_normalize_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_skeleton_css_css_skeleton_css__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_skeleton_css_css_skeleton_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_skeleton_css_css_skeleton_css__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_rx___default.a, { Observable: __WEBPACK_IMPORTED_MODULE_4_rxjs__["Observable"], Subscription: __WEBPACK_IMPORTED_MODULE_4_rxjs__["Subscription"], Subject: __WEBPACK_IMPORTED_MODULE_4_rxjs__["Subject"] });

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);



var API_URL = 'https://api.github.com';

var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: API_URL
});

var get = function get(url, config) {
  return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].fromPromise(http.get(url, config)).map(function (resp) {
    return resp.data;
  }).catch(function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].throw(err.response.data);
  });
};

var search = function search(q, page) {
  return get('/search/repositories', { params: { q: q, sort: 'stars', page: page } });
};

/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      search: ''
    };
  },
  created: function created() {
    var _this = this;

    this.$watchAsObservable('search').pluck('newValue').subscribe(function (q) {
      _this.$router.replace({ name: 'Search', query: { q: q } });
    });
  }
});

/***/ }),

/***/ 106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_api__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'result',
  props: {
    q: String
  },
  data: function data() {
    return {
      title: '',
      typing: false,
      loading: false,
      page: 1,
      error: ''
    };
  },
  subscriptions: function subscriptions() {
    var _this = this;

    var $q = this.$watchAsObservable('q', { immediate: true }).pluck('newValue').do(function () {
      _this.typing = true;
    }).debounceTime(1500).do(function () {
      _this.typing = false;
    }).filter(function (q) {
      return !!q;
    }).do(function () {
      _this.page = 1;
    });

    var $page = this.$watchAsObservable('page', { immediate: true }).pluck('newValue');

    return {
      data: __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].combineLatest($q, $page, function (q, page) {
        return { q: q, page: page };
      }).debounceTime(50).do(function () {
        _this.err = '';
        _this.loading = true;
      }).do(function (_ref) {
        var q = _ref.q;
        _this.title = q;
      }).flatMap(function (_ref2) {
        var q = _ref2.q,
            page = _ref2.page;
        return __WEBPACK_IMPORTED_MODULE_0__services_api__["a" /* search */](q, page).catch(function (err) {
          _this.error = err.message || 'something went wrong :P';
          return __WEBPACK_IMPORTED_MODULE_1_rxjs__["Observable"].of(null);
        });
      }).do(function () {
        _this.loading = false;
      })
    };
  },

  computed: {
    totalPage: function totalPage() {
      if (!this.data) return 0;
      var len = this.data.items && this.data.items.length || 1;
      return Math.ceil(this.data.total_count / len);
    }
  },
  methods: {
    back: function back() {
      if (this.page > 1) --this.page;
    },
    next: function next() {
      if (this.page < this.totalPage) ++this.page;
    }
  }
});

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(79)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(392),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 391:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "u-full-width",
    attrs: {
      "placeholder": "search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("Github Search")])])
}]}

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.title) + " "), (_vm.data && !_vm.loading) ? _c('span', [_vm._v("(" + _vm._s(_vm.data.total_count) + " results)")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typing),
      expression: "typing"
    }]
  }, [_vm._v("Stop typing to search...")]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._v("Loading...")]), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('h5', [_c('a', {
    staticClass: "button",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Back")]), _vm._v(" " + _vm._s(_vm.page) + " / " + _vm._s(_vm.totalPage) + " "), _c('a', {
    staticClass: "button",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("Next")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('table', {
    staticClass: "u-full-width"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data.items), function(x) {
    return _c('tr', [_c('th', [_c('a', {
      attrs: {
        "href": x.html_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(x.name))])]), _vm._v(" "), _c('th', [_c('a', {
      attrs: {
        "href": x.owner.html_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(x.owner.login))])]), _vm._v(" "), _c('th', [_vm._v(_vm._s(x.stargazers_count))])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Owner")]), _vm._v(" "), _c('th', [_vm._v("Star")])])])
}]}

/***/ }),

/***/ 80:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Result__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Result___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Result__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Result___default.a,
    props: function props(to) {
      return { q: to.query.q };
    }
  }]
}));

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(109)

var Component = __webpack_require__(79)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(391),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ })

},[103]);


// WEBPACK FOOTER //
// static/js/app.390b9321a475b5694f6b.js